import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const HelpVideosPage = lazy(() => import('../components/HelpVideosPage'))

export const HelpVideosRoute: RouteObject = {
    path: 'help-videos',
    element: <HelpVideosPage />,
}

export default HelpVideosRoute
